export default {
  carDetails: 'CF - CarDetails',
  carDetailsLikedAd: 'CF - Favorites_CarDetails',
};
